import { Button, Form, Select } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import { actions } from '../../../../../../../../store/reducers/assignments.reducer'
import { EXCEL_ANALYSIS_TYPES } from '../../../../../../../../constants/excel-analysis-types'

const DetermineAnalysisType = ({ excelSheetTypes, setExcelSheetTypes, moveToNextStep }) => {
    const [form] = Form.useForm()

    const handleSubmitClick = fields => {
        setExcelSheetTypes(
            Object.keys(fields).map(field => ({
                name: field,
                type: fields[field],
            })),
        )
        moveToNextStep()
    }

    return (
        <Form name='determine-analysis-type' autoComplete='off' form={form} onFinish={handleSubmitClick}>
            <p>Please, select type of analysis per sheet</p>
            {excelSheetTypes.map((sheet, index) => (
                <Form.Item key={sheet.name + index} label={sheet.name} name={sheet.name} initialValue={sheet.type}>
                    <Select
                        autoFocus
                        size='small'
                        options={Object.keys(EXCEL_ANALYSIS_TYPES).map(analysisType => ({
                            label: EXCEL_ANALYSIS_TYPES[analysisType].name,
                            value: EXCEL_ANALYSIS_TYPES[analysisType].value,
                        }))}
                        popupMatchSelectWidth={false}
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                        showSearch
                        optionFilterProp='label'
                    />
                </Form.Item>
            ))}
            <Form.Item>
                <Button type='primary' htmlType='submit' block>
                    Submit
                </Button>
            </Form.Item>
        </Form>
    )
}

const mapState = ({ assignments }) => {
    return {
        excelSheetTypes: assignments.excelSheetTypes,
    }
}

const mapDispatch = dispatch => {
    return {
        setExcelSheetTypes(value) {
            dispatch(actions.setExcelSheetTypes(value))
        },
    }
}

export default connect(mapState, mapDispatch)(DetermineAnalysisType)
